import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { Switch } from './ui/Switch';
export function SettingsGroup({
  children
}: {
  children: React.ReactNode;
}) {
  return <ul className="rounded-card border border-sand-line bg-white/70 px-2" data-id="element-1402" data-mp="19kd4941zie8u">
      {children}
    </ul>;
}
interface RowProps {
  label: string;
  hint?: string;
  value?: string;
  icon?: React.ReactNode;
  onClick?: () => void;
  tone?: 'default' | 'danger';
}
export function SettingsRow({
  label,
  hint,
  value,
  icon,
  onClick,
  tone = 'default'
}: RowProps) {
  const content = <>
      {icon && <span className="grid h-9 w-9 shrink-0 place-items-center rounded-[12px] bg-sand-deep text-soft" data-id="element-1403" data-mp="qtbxhtumheeq">
          {icon}
        </span>}
      <span className="min-w-0 flex-1" data-id="element-1404" data-mp="vm54kodkcytz">
        <span className={`block text-[13.5px] font-medium ${tone === 'danger' ? 'text-gold-deep' : 'text-deep'}`} data-id="element-1405" data-mp="3uau3rwuqydd1">
          {label}
        </span>
        {hint && <span className="mt-[2px] block text-[11px] leading-snug text-muted" data-id="element-1406" data-mp="344d09yk0czm">
            {hint}
          </span>}
      </span>
      {value && <span className="shrink-0 text-[12px] font-medium text-muted" data-id="element-1407" data-mp="3ubz0yfjq6n1p">{value}</span>}
      {onClick && <ChevronRightIcon size={16} className="shrink-0 text-muted" aria-hidden="true" data-id="element-1408" data-mp="3pgt62r8chy1h" />}
    </>;
  return <li className="border-b border-sand-line last:border-b-0" data-id="element-1409" data-mp="3gi7r1623115g">
      {onClick ? <button type="button" onClick={onClick} className="flex min-h-[56px] w-full items-center gap-2 py-2 text-left" data-id="element-1410" data-mp="3bjeaf4ri0u12">
          {content}
        </button> : <div className="flex min-h-[56px] items-center gap-2 py-2" data-id="element-1411" data-mp="31l8d70gn0c2j">{content}</div>}
    </li>;
}
export function SettingsToggleRow({
  label,
  hint,
  checked,
  onChange,
  emphasis = false
}: {
  label: string;
  hint?: string;
  checked: boolean;
  onChange: (value: boolean) => void;
  /** Health & wellness rows carry the stronger treatment. */
  emphasis?: boolean;
}) {
  return <li className="flex items-center gap-2 border-b border-sand-line py-2 last:border-b-0" data-id="element-1412" data-mp="2z0se6qs4fo9f">
      <span className="min-w-0 flex-1" data-id="element-1413" data-mp="2z2lpwkhlcyoa">
        <span className={`block text-[13.5px] ${emphasis ? 'font-bold text-deep' : 'font-medium text-deep'}`} data-id="element-1414" data-mp="2kcnx1r8pvksr">
          {label}
        </span>
        {hint && <span className="mt-[2px] block text-[11px] leading-snug text-muted" data-id="element-1415" data-mp="3d1lddotdb7iv">
            {hint}
          </span>}
      </span>
      <Switch checked={checked} onChange={onChange} label={label} data-id="element-1416" data-mp="3hxk4vl9zt5ni" />
    </li>;
}